import { CATALOG } from "@/mocks/kanliao";

export default function Catalog() {
  return (
    <section id="catalog" className="relative w-full bg-background-100/70">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-20 md:py-28">
        <div className="mx-auto max-w-2xl text-center">
          <span className="text-xs font-semibold uppercase tracking-widest text-primary-600">检索目录 · 三种找法</span>
          <h2 className="mt-3 font-heading text-3xl font-black text-foreground-950 md:text-4xl">黑料目录怎么逛不迷路</h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600">
            看料站把内容按<strong className="text-foreground-800">人物、事件、时间</strong>三条线索归档，
            无论你记人名、记事件还是只记个大概时间，都能从目录入口直达目标。
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 gap-6 md:grid-cols-3">
          {CATALOG.map((c, idx) => (
            <a
              key={c.key}
              href="#search"
              className="group relative flex flex-col overflow-hidden rounded-xl border border-background-200 bg-background-50 p-6 transition hover:-translate-y-1 hover:border-accent-300"
            >
              <div
                className={
                  "flex h-12 w-12 items-center justify-center rounded-lg " +
                  (idx === 0 ? "bg-primary-500 text-background-50" : idx === 1 ? "bg-accent-500 text-foreground-950" : "bg-secondary-500 text-background-50")
                }
              >
                <i className={"text-2xl " + c.icon} />
              </div>
              <h3 className="mt-5 font-heading text-xl font-bold text-foreground-950">{c.title}</h3>
              <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">{c.lead}</p>
              <div className="mt-5 flex flex-wrap gap-2">
                {c.chips.map((chip) => (
                  <span
                    key={chip}
                    className="whitespace-nowrap rounded-full bg-secondary-100 px-2.5 py-1 text-xs text-secondary-900"
                  >
                    {chip}
                  </span>
                ))}
              </div>
              <div className="mt-5 border-t border-background-200 pt-4 text-xs text-foreground-500">{c.tip}</div>
              <span className="pointer-events-none absolute right-5 top-5 text-foreground-300 transition group-hover:text-primary-500">
                <i className="ri-arrow-right-line text-lg" />
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}